 $('.anouncement-slides').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true
});

 $('.home-banner-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: true
});

$('.home-feature-outer').slick({
    arrows: false,
    pauseOnHover: true,
    autoplay: true,
    autoplaySpeed: 0,  // Infinite scrolling effect
    speed: 3000,  // Control speed of the sliding effect
    infinite: true,
    variableWidth: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: 'linear',  // Ensures smooth continuous scrolling
    centerMode: true,   // Helps avoid empty spaces
    autoplaySpeed: 0,   // Creates a seamless effect
    focusOnSelect: false
});
 $('.home-reviews-right, .installer-steps-wrapper').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: false,
   infinite:false,
   responsive: [
      {
        breakpoint: 600,
        settings: {
          dots: true,
          slidesToShow: 2,   // Ensure only 1 slide is shown
        slidesToScroll: 1,
        variableWidth: true
        }
      },
   {
  breakpoint: 480,
settings: {
  dots: true,
  slidesToShow: 1.7,
  slidesToScroll: 1,
  infinite: false
}
}
    ]
});

 $('.satisfied-slides').slick({
  slidesToShow: 4,
    infinite: false,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: false,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1.3,
        }
      }
    ]
});

 $('.recent-deal-inner').slick({
  slidesToShow: 4,
    infinite: true,
  slidesToScroll: 1,
  arrows: true,
   dots: false,
  autoplay: true,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 479,
        settings: {          
            infinite: false,
          autoplay: false,
          slidesToShow: 1.5,
        }
      }
    ]
});

$('.trusted-partners-wrapper').slick({
  slidesToShow: 6,
    infinite: true,
  slidesToScroll: 1,
  arrows: false,
   dots: false,
  autoplay: true,
   responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 4,
        }
      },
     {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
});

$(document).ready(function() {
    $(".recent-reviews-products").on("click", function(e) {
        e.preventDefault(); // Prevent default behavior

        $("html, body").animate({
            scrollTop: $(".customer-review-outer").offset().top - 80
        }, 800); // Adjust speed (800ms for smooth scrolling)
    });
});
$(document).ready(function () {

  function handleNewsletterSuccess() {
    if (
      window.location.href.includes("customer_posted") ||
      window.location.href.includes("newsletter-popup") ||
      window.location.href.includes("form_type=customer")
    ) {
      $(".newsletter-success").addClass("modal--is-active");
      $(".newsletterpopupsimple").removeClass("modal--is-active");
      $("html").addClass("modal-open");
    }
  }
  handleNewsletterSuccess();
  setTimeout(function () {
    handleNewsletterSuccess();
  }, 2000);

  $(document).on("click", ".modal__close", function () {
    $(".newsletter-success").removeClass("modal--is-active");
    $("html").removeClass("modal-open");
  });

});


jQuery(document).ready(function($) {
  $(".compatible_vehicles_popup_scroll").mCustomScrollbar({});
    // Open popup
    $(".compatible_vehicles_btn").on("click", function() {
        $(".compatible_vehicles_popup_outer").addClass("active");
    });

    // Close popup when clicking on overlay or close icon
    $(".compatible_vehicles_popup_outer, .close-icon").on("click", function() {
        $(".compatible_vehicles_popup_outer").removeClass("active");
    });

    // Prevent closing when clicking inside popup content
    $(".compatible_vehicles_popup_content").on("click", function(event) {
        event.stopPropagation();
    });

    $(".discountcode").click(function () {
        var $this = $(this);
        navigator.clipboard.writeText($this.text().trim()).then(function () {
            $this.attr("data-tooltip", "Gekopieerd naar klembord");
            setTimeout(function () {
                $this.removeAttr("data-tooltip");
            }, 1500);
        });
    });
    
    
});


document.addEventListener("DOMContentLoaded", function () {
  const scrollContainer = document.querySelector(".all-collectionsscroll");
  const activeItem = scrollContainer?.querySelector(".collections-single.active");

  if (!scrollContainer || !activeItem) return;

  const containerRect = scrollContainer.getBoundingClientRect();
  const activeRect = activeItem.getBoundingClientRect();

  // Scroll so active item aligns to LEFT
  const offset =
    activeRect.left -
    containerRect.left +
    scrollContainer.scrollLeft;

  scrollContainer.scrollTo({
    left: offset,
    behavior: "smooth"
  });
});



setTimeout(function () {

    function updateStickyATC() {
        const wrapper = document.querySelector(".zrx-sticky-atc-content-wrapper");
        if (!wrapper) return;

        const button = wrapper.querySelector(".zrx-sticky-atc-main-button");
        const priceWrapper = wrapper.querySelector(".zrx-sticky-atc-product-price-wrapper");

        if (!button || !priceWrapper) return;

        // 👉 Show wrapper after 2 sec
        setTimeout(() => {
            wrapper.style.display = "block"; // or "flex" if needed
            wrapper.style.visibility = "visible";
            wrapper.style.opacity = "1";
        }, 200);

        // 👉 Move price inside button
        if (!button.querySelector(".zrx-custom-wrapper")) {
            const customDiv = document.createElement("span");
            customDiv.className = "zrx-custom-wrapper";

            const priceClone = priceWrapper.cloneNode(true);
            customDiv.appendChild(priceClone);

            button.appendChild(customDiv);
        }

        // 👉 Discount calculation
        const comparePriceEl = wrapper.querySelector(".zrx-sticky-atc-compare-price");
        const priceEl = wrapper.querySelector(".zrx-sticky-atc-product-price");

        if (comparePriceEl && priceEl) {
            const comparePrice = parseFloat(comparePriceEl.innerText.replace(/[^\d.]/g, ""));
            const price = parseFloat(priceEl.innerText.replace(/[^\d.]/g, ""));

            if (!isNaN(comparePrice) && !isNaN(price) && comparePrice > price) {
                const discount = Math.ceil(((comparePrice - price) / comparePrice) * 100);

                if (!button.querySelector(".zrx-discount-badge")) {
                    const badge = document.createElement("span");
                    badge.className = "zrx-discount-badge";
                    badge.innerText = discount + "% KORTING";

                    button.appendChild(badge);
                }
            }
        }

        // 👉 Add tagline BELOW button
        if (!wrapper.querySelector(".btn-tagline")) {
            const tagline = document.createElement("div");
            tagline.className = "btn-tagline";
            tagline.innerHTML = '30 dagen <strong>gratis</strong> uitproberen';

            const actionsWrapper = wrapper.querySelector(".zrx-sticky-atc-product-actions-wrapper");
            if (actionsWrapper) {
                actionsWrapper.appendChild(tagline);
            }
        }
    }

    updateStickyATC();

}, 1800);



document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 767) {
    document.querySelectorAll(".collections-single span").forEach(el => {
      if (el.textContent.trim() === "Telefoonhouders") {
        el.textContent = "Telefoon houders";
      }
    });
  }
});


// document.addEventListener("DOMContentLoaded", () => {

//     const container = document.querySelector(".product-upsell-list__grid");
//     if (!container) return;

//     let items = Array.from(container.querySelectorAll(".product-upsell-list__item"));

//     if (items.length === 0) return;

//     let currentItem = container.querySelector(".product-upsell-list__item--current");

//     items.sort((a, b) => {
//         const priceA = parseFloat(
//             a.querySelector("strong")?.innerText.replace(/[^\d.]/g, "") || 0
//         );
//         const priceB = parseFloat(
//             b.querySelector("strong")?.innerText.replace(/[^\d.]/g, "") || 0
//         );
//         return priceA - priceB;
//     });

//     items.forEach(item => container.appendChild(item));

//     if (currentItem) {
//         items.forEach(el => el.classList.remove("product-upsell-list__item--current"));
//         currentItem.classList.add("product-upsell-list__item--current");
//     }

// });